import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import DataService from "../../services/data.service";
import { getFromSession } from '../../app/util';
import { CustomSVGIcon } from '../layout/dashboard-ui';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { getData, updateAppState } from '../../actions/appstate';
const token = getFromSession("token");

const SigmaDashboard = (props) => {
  const controls = useSelector(state => state.app.current_state.app_state.workspace_controls);
  const dispatch = useDispatch();

  const state = useSelector(state => state);
  const { auth, app } = state;
  const { profile } = auth;
  const { app_state, ui_state } = useSelector(
    (state) => state.app.current_state
  );
  const handleSubmit = async () => {
    let payload = {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Authorization": "Token " + token,
      },
      redirect: "follow",
    }
    try {
      const data = await DataService.getData({ api: 'ea/s/url/', request: payload });
      if (data.status === "success") {
        controls.sigmaDashboard = true;
        controls.sigmaDashboardUrl = data.url;
        dispatch(
          updateAppState("segmaupdate", {
            app_state: {
              workspace_controls: controls,
              data_load: true
            },
            ui_state: { showspinner: true }
          }));
      } else {
        console.log("some error occour!");
      }
    } catch (err) {
      console.log(err);
    }
  }
  useEffect(() => {
    handleSubmit();
  }, [])
  let url = app_state.workspace_controls.sigmaDashboardUrl;

  return (
    <div style={{ "height": "100vh" }}>
      <iframe src={url} height="100%" width="100%" frameBorder={"none"} />
    </div>
  )
}

export default SigmaDashboard
